import { create } from 'zustand'

type ServiceUnavailableError = {
  code: number
  contactPhone: string
  message: string
  title: string
}

export enum RefreshSessionStatus {
  None = 'none',
  Loading = 'loading',
  Error = 'error'
}

type ServiceErrorsStoreType = {
  error?: ServiceUnavailableError

  isDown: boolean
  setDown: (error?: ServiceUnavailableError) => void

  isContentLarge: boolean
  setIsContentLarge: (isContentLarge: boolean) => void

  refreshSessionStatus: RefreshSessionStatus
  setRefreshSessionStatus: (status: RefreshSessionStatus) => void
}

export const useServiceErrorsStore = create<ServiceErrorsStoreType>(
  (set, get) => ({
    error: undefined,

    isDown: false,
    setDown: error => {
      if (!get().isDown) {
        set({ isDown: true, error })
      }
    },

    isContentLarge: false,
    setIsContentLarge: isContentLarge => {
      set({ isContentLarge: isContentLarge })
    },

    refreshSessionStatus: RefreshSessionStatus.None,
    setRefreshSessionStatus: status => {
      set({ refreshSessionStatus: status })
    }
  })
)
